import { decimal } from 'Helpers/currencyFormat';

// Batch statuses that are still moving, so their status is polled.
export const IN_PROGRESS_STATUSES = ['queued', 'writing'];

export const POLL_INTERVAL_MS = 4000;

/**
 * Money to two decimals, negatives in brackets — the same as the template's
 * Amount column, so a figure on screen reads exactly as it does in the file.
 */
export const formatAmount = (value) => {
    const number = Number(value) || 0;

    return number < 0 ? `(${decimal(Math.abs(number), 2)})` : decimal(number, 2);
};

export const formatCount = (value) => decimal(Number(value) || 0, 0);

export const statusBadge = (status) => {
    switch (status) {
        case 'validating':
            return { variant: 'info', label: $t('Checking') };
        case 'validated':
            return { variant: 'info', label: $t('Validated') };
        case 'not_uploaded':
            return { variant: 'neutral', label: $t('Checked, not uploaded') };
        case 'blocked':
            return { variant: 'danger', label: $t('Blocked') };
        case 'queued':
            return { variant: 'info', label: $t('Queued') };
        case 'writing':
            return { variant: 'info', label: $t('Writing') };
        case 'loaded':
            return { variant: 'success', label: $t('Loaded') };
        case 'failed':
            return { variant: 'danger', label: $t('Failed') };
        default:
            return { variant: 'neutral', label: status };
    }
};

export const severityBadge = (severity) => {
    switch (severity) {
        case 'file':
            return { variant: 'danger', label: $t('File blocked') };
        case 'blocked':
            return { variant: 'danger', label: $t('Row blocked') };
        case 'gap':
            return { variant: 'warning', label: $t('Loads with gap') };
        case 'note':
            return { variant: 'info', label: $t('Note') };
        default:
            return { variant: 'neutral', label: severity };
    }
};

/**
 * The message a failed request carries: a validation error on the file, the
 * endpoint's own error, or a generic line when the server gave nothing usable.
 */
export const errorMessage = (error) => {
    const data = error?.response?.data;

    if (error?.response?.status === 403 && !data?.metadata?.show_toast) {
        return $t("You don't have permission to do this. Ask a project administrator for access.");
    }

    if (data?.errors) {
        const first = Object.values(data.errors).flat()[0];
        if (first) {
            return first;
        }
    }

    if (data?.reason) {
        return data.reason;
    }

    if (data?.error) {
        return data.error;
    }

    if (error?.response?.status >= 500 || data?.message) {
        return $t('Something went wrong on our side. The error has been reported; please try again, or contact support if it keeps happening.');
    }

    return $t('The request could not be completed. Check your connection and try again.');
};
